import React, { useEffect } from "react";
import { Redirect, useHistory } from "react-router-dom";
import { chakra, Icon, Text, Flex, Box, Grid, Button } from "@chakra-ui/react";
import { ExclamationIcon } from "@heroicons/react/solid";
import { motion, isValidMotionProp } from "framer-motion";
import { Trans } from "react-i18next";
import { _basePath } from "../../config";
import { UserContext } from "../../context";

const FramerBox = chakra(motion.div, {
  shouldForwardProp: (prop) => isValidMotionProp(prop) || prop === "children",
});

const motionProps = {
  initial: { y: 40, opacity: 0 },
  animate: { y: 0, opacity: 1 },
  exit: { opacity: 0, y: -40 },
  transition: {
    type: "tween",
    duration: 0.5,
  },
};

const SelectUser = ({ options, value }) => {
  const history = useHistory();

  const {
    userData: { user, users, loggedIn },
    setUserData,
  } = React.useContext(UserContext);

  useEffect(() => {
    if (user && loggedIn) {
      history.push(`${_basePath}/welcome`);
    }
  }, [user, loggedIn]);

  const onSelect = function (e) {
    setUserData({
      user: options[e],
      loggedIn: true,
    });
  };
  if (!users?.length) {
    return <Redirect to={_basePath} />;
  }
  return (
    <Flex
      flex={1}
      h={"100vh"}
      justifyContent={"center"}
      direction={"column"}
      mx={{ base: 5, sm: 10, md: 20 }}
      my={0}
      overflow={"hidden"}
    >
      <FramerBox {...motionProps} textAlign="center">
        <Icon as={ExclamationIcon} boxSize={20} color={"yellow.400"} />
        <Box textAlign="center" mb={12}>
          <Text fontWeight={"normal"} fontSize="3xl">
            <Trans
              i18nKey={"found_multiple_accounts"}
              values={{ entered: value }}
            >
              We found multiple accounts that match <strong>{value}</strong>
            </Trans>
          </Text>
          <Text fontWeight={"normal"} fontSize="2xl">
            <Trans i18nKey={"please_select_your_name"}>
              Please select your name from the list below.
            </Trans>
          </Text>
        </Box>
      </FramerBox>
      <FramerBox {...motionProps} textAlign="center" w="full" className="test">
        <Grid
          templateColumns={{
            base: "1fr",
            sm: "repeat(2, 1fr)",
            md: "repeat(3, 1fr)",
          }}
          // display="grid"
          gap={{ base: 4, sm: 6, md: 8 }}
          // p={4}
          m="0 auto"
          maxW={"1024"}
        >
          {options.map((user, idx) => (
            <Button
              size={"lg"}
              key={user.id}
              variant={"default"}
              data-testid={`user-${user.id}`}
              onClick={() => onSelect(idx)}
            >
              <Text noOfLines={2}>
                {user.FirstName} {user.LastName?.charAt(0)}
              </Text>
            </Button>
          ))}
        </Grid>
      </FramerBox>
    </Flex>
  );
};
export default SelectUser;
